<section id="origin" class="wrapper">
  <h3 class="title" [ngClass]="{ 'mobile-padding-left': !isContentLandingPage }">{{ title }}</h3>

  <div class="category-grid">
    <div
      class="category-card"
      appDisableClickEvent
      (click)="
        fireGAEvent(card.categoySelectionLink.selectedSlug);
        goTo(card.categoySelectionLink.selectedSlug, card.categoySelectionLink.pageType)
      "
      *ngFor="let card of cards | slice: 0:limit"
    >
      <img [src]="card.image.filename + sbFormatParam" [alt]="card.image.alt" />
      <h4>{{ card.title }}</h4>
    </div>
  </div>

  <div class="expander" *ngIf="isMobile && cards.length > NOT_EXPANDED_LIMIT">
    <button type="button" class="toggle" (click)="toggleExpanded()">
      {{ (isExpanded ? 'SHARED.SHOW_LESS.LABEL' : 'SHARED.SHOW_MORE.LABEL') | translate }}
    </button>

    <mat-icon *ngIf="!isExpanded">expand_more</mat-icon>
    <mat-icon *ngIf="isExpanded">expand_less</mat-icon>
  </div>
</section>
